import { render, staticRenderFns } from "./new-contact-dialog.vue?vue&type=template&id=0ec23eca&scoped=true&"
import script from "./new-contact-dialog.vue?vue&type=script&lang=js&"
export * from "./new-contact-dialog.vue?vue&type=script&lang=js&"
import style0 from "./new-contact-dialog.vue?vue&type=style&index=0&id=0ec23eca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ec23eca",
  null
  
)

export default component.exports